import PreQualifiedForm from './Form/PreQualifiedForm';
import styles from './PreQualifiedModal.module.scss';

const PreQualifiedModal = () => {
  return (
    <div className={styles.wrapper}>
      <PreQualifiedForm />
    </div>
  );
};

export default PreQualifiedModal;
